module.exports = __webpack_public_path__ + "48cf4c8f8ca52950a955830be86d5fa7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/special-conditions/diabetico.png
// module id = 180
// module chunks = 0